import React from 'react'
import { Button } from 'antd'
import moment, { Moment } from 'moment'
import { RangeValue } from 'rc-picker/lib/interface'
import { CalendarOutlined } from '@ant-design/icons'

type Props = {
  ranges?: RangeValue<Moment>
  setRanges: (values: RangeValue<Moment>) => void
}

export const Shortcuts: React.FunctionComponent<Props> = ({
  ranges,
  setRanges,
}) => {
  const applyDayInterval = () => {
    setRanges([moment().startOf('day'), moment().endOf('day')])
  }

  const applyWeekInterval = () => {
    setRanges([moment().startOf('week'), moment().endOf('week')])
  }

  const applyMonthInterval = () => {
    setRanges([moment().startOf('month'), moment().endOf('month')])
  }

  return (
    <>
      <Button size="large" onClick={applyDayInterval}>
        {' '}
        <CalendarOutlined /> День{' '}
      </Button>
      <Button size="large" onClick={applyWeekInterval}>
        {' '}
        <CalendarOutlined /> Неделя{' '}
      </Button>
      <Button size="large" onClick={applyMonthInterval}>
        {' '}
        <CalendarOutlined /> Месяц{' '}
      </Button>
    </>
  )
}
